import { AxiosResponse } from 'axios';
import api from './Api'

export const createProgramReview = (params: ICreateProgramReviewWebRequest): Promise<AxiosResponse<boolean>> => {
    return api.post(`/program/review/web/v2`, params)
}

export const getProgramReviewByProgramBookingId = (programBookingId: string): Promise<AxiosResponse<IWellnessLectureReview>> => {
    return api.get(`/program/review/web/v2/${programBookingId}`)
}

export const updateProgramReview = (params: IUpdateProgramReviewWebRequest): Promise<AxiosResponse<boolean>> => {
    return api.put(`/program/review/web/v2`, params)
}

export const deleteProgramReviewByProgramReviewId = (programReviewId: string): Promise<AxiosResponse<boolean>> => {
    return api.delete(`/program/review/web/v2/${programReviewId}`)
}